import React from "react";
import { Select, MenuItem, Button } from "@mui/material";
import { Edit } from "@mui/icons-material";

// Editor fuer die "hat Aufzählung"-Spalte, identisch fuer Realestate-/Administrative-/Component-Typen.
function EnumeratorLookupEditor(props) {
    const options = props.rowData.enumeratorValues || [{"text": ""}, {"value": ""}];
    return (
        <Select
            value={props.value || ""}
            onChange={(e) => props.onChange(e.target.value)}
            fullWidth
        >
            {options.length > 0 ? (
                options.map((val) => (
                    <MenuItem key={val.text} value={val.value}>
                        {val.text}
                    </MenuItem>
                ))
            ) : (
                <MenuItem disabled>No options</MenuItem>
            )}
        </Select>
    );
}

// Baut die MaterialTable-Spalten fuer die Feldliste, abhaengig vom gewaehlten fieldType.
export function buildFieldColumns(fieldType, onEditEnumerator) {
    if (fieldType === 'realestateobjectType' || fieldType === 'administrativeobjectType') {
        return [
            {title: 'guid', field: 'guid', hidden: true},
            {title: 'Bezeichnung', field: 'label'},
            {
                title: 'Typ',
                field: 'type',
                lookup: {
                    "text": 'String',
                    "number": 'Number',
                    "integer": 'Integer',
                    "real": "Real",
                    "boolean": 'Boolean',
                    "date": 'Date',
                    "time": 'Time'
                },
            },
            {title: 'Cockpit-Feldname', field: 'mappedField'},
            {
                title: 'Aufzählung', field: 'hasEnumerator', lookup: {0: 'nein', 1: 'ja'},
                editComponent: EnumeratorLookupEditor,
            },
            {title: 'Sortierung', field: 'position', type: 'numeric'},
            {
                title: "Aufzählung bearbeiten",
                field: "enumerators",
                render: (rowData) => (
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<Edit />}
                        onClick={() => onEditEnumerator(rowData)}
                    >
                        Bearbeiten
                    </Button>
                ),
                editable: "never",
            },
        ];
    }

    if (fieldType === 'componentType') {
        return [
            {title: 'guid', field: 'guid', hidden: true},
            {title: 'catalog_property_guid', field: 'catalog_property_guid', hidden: true},
            {title: 'Bezeichnung', field: 'name', editable: 'never'},
            {
                title: 'Typ',
                field: 'type',
                lookup: {
                    "String": 'String',
                    "Integer": 'Integer',
                    "Real": "Real",
                    "Boolean": 'Boolean',
                    "Date": 'Date',
                    "Time": 'Time',
                },
                editable: 'never'
            },
            {title: 'Cockpit-Feldname', field: 'mappedField'},
            {
                title: 'hat Aufzählung', field: 'hasEnumerator', lookup: {false: 'nein', true: 'ja'},
                editComponent: EnumeratorLookupEditor,
            },
        ];
    }

    return [
        {title: 'guid', field: 'guid', hidden: true},
        {title: 'Bezeichnung', field: 'label'},
        {
            title: 'Typ',
            field: 'type',
            lookup: {
                "text": 'Text',
                "number": 'Nummer',
                "integer": 'Integer',
                "real": "Real",
                "boolean": 'Boolean',
                "date": 'Datum'
            },
        },
        {title: 'Cockpit-Feldname', field: 'mappedField'},
        {title: 'Sortierung', field: 'position', type: 'numeric'},
    ];
}
